/* tslint:disable */

declare var Object: any;
export interface ERPdataAuthInterface {
  "id"?: number;
}

export class ERPdataAuth implements ERPdataAuthInterface {
  "id": number;
  constructor(data?: ERPdataAuthInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPdataAuth`.
   */
  public static getModelName() {
    return "ERPdataAuth";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPdataAuth for dynamic purposes.
  **/
  public static factory(data: ERPdataAuthInterface): ERPdataAuth{
    return new ERPdataAuth(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPdataAuth',
      plural: 'ERPdataAuths',
      path: 'ERPdataAuths',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPdataAuth.ts